'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _doctifyUtils = require('doctify-utils');

var _doctifyModal = require('../../src/styles/doctify-modal.scss');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

require('../../src/styles/external.scss');

require('../../src/styles/vars.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import messages from '../lang/default-messages';

// import { FormattedMessage } from 'react-intl';

var overlay = void 0;
var modalContainer = void 0;

var DoctifyModal = function DoctifyModal(props) {
	return _react2.default.createElement(
		'div',
		{ className: _doctifyModal2.default.backgroundOverlay,
			onClick: function onClick(event) {
				if (event.target === overlay) {
					(0, _doctifyUtils.closeModal)(props, overlay);
				}
			},
			ref: function ref(div) {
				overlay = div;
				if (overlay) {
					overlay.addEventListener('wheel', (0, _doctifyUtils.stopScroll)(_doctifyModal2.default.modalContainer, overlay), true);
					overlay.addEventListener('touchmove', (0, _doctifyUtils.stopScrollMobile)(_doctifyModal2.default.modalContainer), true);
					overlay.addEventListener('touchstart', _doctifyUtils.setLastY, true);
				}
			} },
		_react2.default.createElement(
			'div',
			{ ref: function ref(div) {
					modalContainer = div;
				},
				className: _doctifyModal2.default.modalContainer + ' form-horizontal ' + (props.className || '') },
			props.header && _react2.default.createElement(
				'div',
				{ className: _doctifyModal2.default.header + ' ' + (props.headerClass || '') },
				_react2.default.createElement(
					'div',
					{ className: _doctifyModal2.default.title + ' ' + (props.titleClass || '') },
					props.header
				),
				props.showClose && _react2.default.createElement(
					'button',
					{
						className: _doctifyModal2.default.close,
						onClick: function onClick() {
							(0, _doctifyUtils.closeModal)(props, overlay);
						}
					},
					_react2.default.createElement('i', { className: 'ion-android-close' })
				)
			),
			_react2.default.createElement(
				'div',
				{ id: props.bodyStyles, className: props.bodyClass },
				props.children
			)
		)
	);
};

DoctifyModal.propTypes = {
	children: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
	className: require('react').PropTypes.string.isRequired,
	bodyStyles: require('react').PropTypes.string.isRequired,
	bodyClass: require('react').PropTypes.string.isRequired,
	header: require('react').PropTypes.any.isRequired,
	headerClass: require('react').PropTypes.string.isRequired,
	titleClass: require('react').PropTypes.string.isRequired,
	showClose: require('react').PropTypes.bool
};
DoctifyModal.displayName = 'DoctifyModal';

DoctifyModal.defaultProps = {
	showClose: true
};

exports.default = DoctifyModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/doctify-modal.js